import { render, staticRenderFns } from "./integralRecord.vue?vue&type=template&id=1f2bafbe&"
import script from "./integralRecord.vue?vue&type=script&lang=js&"
export * from "./integralRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports